import Button from "antd/lib/button";

import { IFirebaseNotification } from "components/FirebaseNotification/IFirebaseNotification";
import {  useAppSelector } from "core/redux/store/hooks";

import { useCallback, useEffect, useState } from "react";
import { FaRegEnvelope } from "react-icons/fa";
import { getFirebaseToken, onMessageListener } from "utils/firebase";
import i18n from "utils/i18n";
import { customNotification } from "../CustomNotification/CustomNotification";
import "./FirebaseNotificatin.css";
import NotificheRepository from "core/data/NotificheRepository";
import { INotiticheUtente } from "core/interfaces/data/INotificheUtente";
import { selectNotification, setNotification } from "core/redux/features/notification/notificationSlice";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import { Enhanced } from "utils/ReactUtils";

const FirebaseNotification: React.FC<IFirebaseNotification> = ({ className, onClick, text ,dispatch,sessionInfo, handleError}) => {
	
	const notification = useAppSelector(selectNotification);


	const [isTokenFound, setTokenFound] = useState(false);

	if (!isTokenFound && sessionInfo.isLogged && !sessionInfo.tokenFCM) {
		getFirebaseToken(setTokenFound, sessionInfo.sessione?.idSessione, i18n.language);
	}

	const setNotifiche = useCallback(
		(notifiche: Array<INotiticheUtente>) => {
			dispatch(setNotification(notifiche));
		},
		[dispatch]
	);

	useEffect(() => {
		performAsyncFunction(async () => {
			if (sessionInfo.isLogged) {
				if (!(notification.notications.length > 0)) {
					var notifiche = await NotificheRepository.GetNotiticheUtente({
						IdSessione: sessionInfo.sessione?.idSessione,
						culture: i18n.language,
						NumeroNotifiche: undefined,
					});
					setNotifiche(notifiche);
				}

				let token = await getFirebaseToken(setTokenFound, sessionInfo.sessione?.idSessione, i18n.language);
				if (token) setTokenFound(true);
			}
		}, handleError);
	}, [handleError, notification.notications.length, sessionInfo.isLogged, sessionInfo.sessione?.idSessione, setNotifiche]);

	onMessageListener()
		.then((payload: any) => {
			let not = notification.notications;
			let newNotifica: INotiticheUtente = JSON.parse(payload?.notification?.body);

			customNotification(newNotifica.Title, newNotifica.Body, "info", undefined, "top");
			not.push(newNotifica);
			setNotifiche(not);
		})
		.catch((err) => console.log("failed: ", err));

	return (
		<>
			<Button className={className} onClick={onClick} hidden={!sessionInfo.isLogged}>
				<FaRegEnvelope className="notification-ico" />
				{(notification.unreadNotification ?? 0) > 0 && <span className="notification-number">{notification.unreadNotification}</span>}
				{text}
			</Button>
		</>
	);
};
export default Enhanced( FirebaseNotification,{componentNamespace:"FirebaseNotification"});
